import { render } from "./HowToPlayView.vue?vue&type=template&id=5d651818&scoped=true"
import script from "./HowToPlayView.vue?vue&type=script&lang=js"
export * from "./HowToPlayView.vue?vue&type=script&lang=js"

import "./HowToPlayView.vue?vue&type=style&index=0&id=5d651818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d651818"]])

export default __exports__